@if (isImpersonated()) {
  <div class="flex justify-center gap-0.5 bg-red p-1 text-center text-black">
    <div>
      Vous agissez actuellement en tant que
      @if (openIdUserData(); as user) {
        {{ user.name }} ({{ user.email | obfuscateEmail }}).
      }
    </div>
    <button mat-button class="link" (click)="closeImpersonate()">Revenir à mon compte.</button>
  </div>
}
